// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_ic-0";